/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        ...theme.custom.applicationViewPage.tabs.overview.styles
    },
    container: {
        paddingTop: '46px',
        paddingBottom: theme.spacing(4),
        maxWidth: '1480px',
    },
    loaderContainer: {
        width: "cal(100%-60px)",
        height: "70%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    componentPadding: {
        paddingLeft: theme.spacing(7),
        paddingRight: theme.spacing(8),
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
        },
        [theme.breakpoints.up('lg')]: {
            paddingLeft: 'auto',
            paddingRight: 'auto',
        }
    },
    table: {
        width: '80%',
    },
    leftCol: {
        width: 200,
        paddingLeft: 0,
    },
    firstRow: {
        borderBottom: "none",
        paddingBottom: theme.spacing(1)
    },
    overviewKeys: {
        ...theme.custom.applicationViewPage.tabs.overview.overviewRowKeyTextStyle
    },
    overviewDescription: {
        ...theme.custom.applicationViewPage.tabs.overview.overviewRowValueTextStyle
    },
    overviewValues: {
        ...theme.custom.applicationViewPage.tabs.overview.overviewRowValueTextStyle
    },
    overviewOwnerEmail: {
        ...theme.custom.applicationViewPage.tabs.overview.overviewRowValueTextStyle,
        color: theme.palette.primary.main
    },
    emailChip: {
        ...theme.custom.applicationViewPage.tabs.overview.emailChipStyle,
        borderRadius: theme.spacing(0.7),
    }
}));
